import React, {useState} from 'react';

import './Tools.css'
import ColorButton from "../../../2/ColorButton";



const Tools = (props) => {
    const [fSize, setFontSize] = useState(14);
    const [fontFamily, setfontFamily] = useState({
        selectedOption: 'SGKara',
        options: ['SGKara', 'Sans', 'Vazir']
    });
    const [Image, setImage] = useState();
    const [Logo, setLogo] = useState();
    const [colorText,setColorText]=useState({
            r: '74',
            g: '74',
            b: '74',
            a: '1',
    },
    );

    function changeFontSize(e) {
        setFontSize(e.target.value);
        return props.fontSize(e)
    }

    const handleEventFont = event => {
        const {target} = event;

        setfontFamily(fontFamily => ({
            ...fontFamily,
            selectedOption: target.value
        }));
        return props.fontFamily(event)
    };

    const handleColorText = event =>
    {
        setColorText(event.hex);
        return props.colorText(event.hex)
    };



    function importIcon(e) {
        if (e.target.files[0]) {

            var reader = new FileReader();
            reader.onload = function (event) {
                setImage(event.target.result);
                return props.backgroundUpload(event.target.result);
            };
            reader.readAsDataURL(e.target.files[0]);
        }


    }


    function importLogo(e) {
        if (e.target.files[0]) {

            var reader = new FileReader();
            reader.onload = function (event) {
                setLogo(event.target.result);
                return props.logoUpload(event.target.result);
            };
            reader.readAsDataURL(e.target.files[0]);
        }
    }

    function deleteLogo(e) {
        if (Logo) {
            setLogo(null);
            return props.delete(e);
        }

    }


    return (
        <div className="tools">
            <label className="bg-secondary text-light w-100">Tools</label>

            <div className="form-group">
                <label>Select Size</label>
                <div className="d-flex justify-content-center">
                    <button onClick={() => props.postSize('post')}
                            className="form-control-sm btn btn-sm btn-info m-1">Post
                    </button>
                    <button onClick={() => props.storySize('story')}
                            className="form-control-sm btn btn-sm btn-info m-1">Story
                    </button>
                </div>
            </div>

            <div className="form-group">
                <label className="w-100">Font Size</label>

                <input className="form-control-sm" type="range" min="14" max="55" value={fSize}
                       onChange={changeFontSize}/>
                <label className="w-100">{fSize}</label>
            </div>

            <div className="btn-group btn-group-sm" role="group" aria-label="Small button group">
                <button type="button" className="btn btn-secondary" value="left" onClick={props.align}>Left</button>
                <button type="button" className="btn btn-secondary" value="center" onClick={props.align}>Center</button>
                <button type="button" className="btn btn-secondary"  value="right" onClick={props.align}>Right</button>
            </div>

            <div className="form-group">
                <label className="w-100" >Color Text</label>
                <ColorButton color={colorText} onChange={handleColorText}/>
            </div>



            <div className="form-group">
                <label className="w-100">Font</label>
                <select className="form-control-sm" value={fontFamily.selectedOption} onChange={handleEventFont}>
                    {fontFamily.options.map((option, id) => <option key={id} value={option}>{option}</option>)}
                </select>
            </div>

            <div className="form-group">
                <label className="w-100">Background</label>

                <input className="form-control-file" type="file" id="imageLoader" name="imageLoader"
                       onChange={importIcon}/>

            </div>

            <div className="form-group">
                <label className="w-100">Logo</label>

                {!Logo
                    ?
                    <input className="form-control-file" type="file" id="logoLoader" name="logoLoader"
                           onChange={importLogo}/>
                    :
                    <div>
                    <img src={Logo} width="50"/>
                    < button className="btn btn-sm btn-light m-2" onClick={deleteLogo}>Delete </button>
                    </div>
                }

             </div>


            <div className="form-group mt-5">

                <button className="btn btn-primary mt-5" onClick={props.export} > Save $ Share</button>
            </div>

        </div>
    );
};

export default Tools;
